import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';
import { PageScrollService } from 'ngx-page-scroll-core';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from 'src/environments/environment.demo';
import { MsalService } from '@azure/msal-angular';
import { SilentRequest } from '@azure/msal-browser';

@Component({
  selector: 'app-asset-details',
  templateUrl: './asset-details.component.html',
  styleUrls: ['./asset-details.component.scss']
})
export class AssetDetailsComponent implements OnInit {

  image = '../../../../assets/images/assets-banner.jpg';
  bannerTitle = 'Asset Details';
  active: any;
  mailText: string;
  assetDetail: any;
  filledRatingStars: any;
  unfilledRatingStars: any;
  overviewList: any;
  ratingList: any;
  totalRatingSum = 0;

  pageSections = [
    { linkHash: "overview", linkTitle: "Overview", active: true },
    { linkHash: "resourcesAndLinks", linkTitle: "Resources and Links" },
    { linkHash: "contributors", linkTitle: "Contributors" },
    { linkHash: "reviews", linkTitle: "Reviews" },
  ]
  username: any;
  accessCodePresent: boolean = true;
  apiTimer: any;

  requesttoken: SilentRequest = {
    scopes: [environment.clientId + '/user.read'],
    account: undefined,
    // account: this.msalService.instance.getAllAccounts()[0]
  };
  constructor(private router: Router,private authService: MsalService, private _appService: AppService, @Inject(DOCUMENT) private document: any, private PageScrollService: PageScrollService, private activatedRoute: ActivatedRoute, private location: Location) { }

  ngOnInit(): void {
    this._appService.checkRefreshTokenValidity();
    this.requesttoken.account = this.authService.instance.getAllAccounts()[0]
        this.authService.acquireTokenSilent(this.requesttoken).subscribe(result => {
          // console.log("SilentToken response in AssetDetailsComponent...", result);
          sessionStorage.setItem('accessToken', result.accessToken);
          this._appService.jwtAuthorizationToken=result.accessToken;
          this.loadData();
        })
  }

  loadData(){
    this._appService.getUsername().subscribe(userdata => this.username = userdata);

  this.apiTimer = setInterval(()=>{
    // if (typeof history.state.Asset_Name == 'undefined') {
    this._appService.getAllAssets(1, this.activatedRoute.snapshot.params.asset_id, this.username).subscribe((res) => {
      this.assetDetail = res[0];
      this.initialData();
      if(this.assetDetail){
        clearInterval(this.apiTimer);
      }
    })
    // } else {
    //   this.assetDetail = history.state;
    //   this.initialData()
    // }
  },2000)
  }
  ngDoCheck() {
    let scrollPosition = window.pageYOffset;

    if (scrollPosition >= 215) {
      document.getElementById('lastupdate')?.classList.add('pos-fixed');
    } else {
      document.getElementById('lastupdate')?.classList.remove('pos-fixed');
    }
  }

  initialData() {
    this.filledRatingStars = Array(Math.round(parseFloat(this.assetDetail.Average_Rating))).fill(0).map((x, i) => i);
    this.unfilledRatingStars = Array(5 - Math.round(parseFloat(this.assetDetail.Average_Rating))).fill(0).map((x, i) => i);
    this.overviewList = [{ overviewLabel: "Nature of asset", overviewDescription: this.assetDetail.Asset_Nature_Name },
    { overviewLabel: "Type of asset", overviewDescription: this.assetDetail.Asset_Type_Name },
    { overviewLabel: "Technology stack", overviewDescription: this.assetDetail.Technology_Stack_Name },
    { overviewLabel: "Asset Description", overviewDescription: this.assetDetail.Asset_Description },
    ]
    this._appService.getRatingDetails(this.assetDetail.Asset_Id).subscribe((res => {
      this.ratingList = res;
      this.ratingList.forEach((element: any) => {
        this.totalRatingSum = this.totalRatingSum + element.RatingCount;
      });
    })
    )
    if (this.assetDetail.Resources['access_code'] == null || this.assetDetail.Resources['access_code'] == "Not Filled" || this.assetDetail.Resources['access_code']=="") this.accessCodePresent = false; else this.accessCodePresent = true;
  }


  onBookmarkClick() {
    this.assetDetail.User_BookMarked_Assets = !this.assetDetail.User_BookMarked_Assets
    this._appService.addAssetBookmarked(this.assetDetail.User_BookMarked_Assets, this.assetDetail.Asset_Id, this.username).subscribe();
  }

  scrollTo(containerID: any) {
    this.active = containerID;
    this.PageScrollService.scroll({
      document: this.document,
      scrollTarget: '#' + containerID,
    });
  }

  onSectionChange(event: any) {
    if (event === undefined) {
      this.pageSections.forEach((item) => {
        item.active = false;
        return item;
      });
      this.pageSections[0].active = true;
    } else {
      this.pageSections.map((item) => {
        if (item.linkHash === event) {
          item.active = true;
        } else {
          item.active = false;
        }
        return item;
      });
    }
  }


  // Send Mail to open Feedback Dialog
  ShareAssetonOutlook() {
    this.mailText = `mailto:?subject=Industry X Portal | New Asset Shared with you
  &body=Hello!%0D%0A%0D%0ACheck out this useful asset from the Industry X Portal - ${window.location.href}
  %0D%0A%0D%0AI believe that this asset would be helpful for your current project or assignment.
  You can also check out more on the Industry X portal. - ${environment.portalURL}`;
    window.location.href = this.mailText;
  }

  navigateBack() {
    this.location.back();
  }
}